import {getBrowserLocalStorage} from "axios-jwt";

const AuthTokenStorage = getBrowserLocalStorage
export default AuthTokenStorage
